<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="titlePage mb-3">Ferramentas</div>
      </b-col>
    </b-row>
    <b-row class="ml-1">
      <b-tabs class="w-100" v-model="abaFerramentas">
        <b-tab title="Boletos" active>
          <FccAbaBoletos :controlePage="controlePage" v-if="abaFerramentas == 0" />
        </b-tab>
        <b-tab title="Inclusão de Pagamento">
          <FccAbaInserirPagamento :controlePage="controlePage" v-if="abaFerramentas == 1" />
        </b-tab>
      </b-tabs>
    </b-row>
  </div>
</template>

<script>
import FccAbaBoletos from './fccAbaBoletos.vue'
import FccAbaInserirPagamento from './fccAbaInserirPagamento.vue'
export default {
  components: { FccAbaBoletos, FccAbaInserirPagamento },
  props: {
    controlePage: Object
  },
  data() {
    return {
      abaFerramentas: 0
    }
  }
}
</script>
